module.exports = __webpack_public_path__ + "img/29.61c06b97.jpg";